export default __webpack_public_path__ + "static/media/vision-section-05.52986ee9.webp";